import { Loader2Icon } from 'lucide-react'
import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

export interface ToolSelectorLoadingProps {
  className?: string
}

/**
 * Loading state component for the tool selector.
 * Shows a spinner with loading text while tools are being fetched.
 */
export const ToolSelectorLoading = ({ className }: ToolSelectorLoadingProps): ReactNode => {
  return (
    <div
      className={cn(
        'tool-selector-loading flex h-9 items-center gap-2 rounded-md border px-3 py-2',
        className
      )}
    >
      <Loader2Icon className="size-4 animate-spin" />
      <span className="text-sm text-muted-foreground">Loading tools...</span>
    </div>
  )
}

ToolSelectorLoading.displayName = 'ToolSelectorLoading'
